import axios from "../utils/axios";

export const getAgencySection = async () => {
    const response = await axios.get('/agency-section');
    return response.data;
};

export const updateAgencySection = async (data) => {
    const response = await axios.put('/agency-section', data);
    return response.data;
};
